import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const SidebarSection = props => {
  return /*#__PURE__*/_jsx(View, {
    paddingInline: props.flush ? '0' : '500',
    paddingBlock: "500",
    backgroundColor: props.enclosed ? 'border-core-subtle' : undefined,
    "data-onboarding": props.onBoarding || '',
    "data-test-id": props.testId || '',
    children: props.children
  });
};
export default SidebarSection;